module.exports = __webpack_public_path__ + "portal-static/img/cj.2ab90eef.png";